import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eleven_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/portal")) {
      localStorage.removeItem("eleven_token");
      localStorage.removeItem("eleven_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// Capture UTM params once per session
export function captureUTM() {
  try {
    const params = new URLSearchParams(window.location.search);
    const existing = sessionStorage.getItem("eleven_utm");
    const utm = existing ? JSON.parse(existing) : {};
    let found = false;
    ["source", "medium", "campaign"].forEach((k) => {
      const v = params.get(`utm_${k}`);
      if (v) {
        utm[k] = v;
        found = true;
      }
    });
    if (found || !existing) {
      sessionStorage.setItem("eleven_utm", JSON.stringify(utm));
    }
  } catch (e) {
    /* noop */
  }
}

export function getUTM() {
  try {
    return JSON.parse(sessionStorage.getItem("eleven_utm") || "{}");
  } catch (e) {
    return {};
  }
}
